import { V2Networks } from '@shared/utils/config/networkAddresses';
import { IoTriangle } from 'react-icons/io5';
import { useRouter } from 'next/router';
import { useSession } from '@/contexts/LitSessionProvider';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { CATEGORIES, EVENTS, LogToMixpanel } from '@/lib/misc/mixpanel';
import { Skeleton } from '@/components/ui/skeleton';
import TokenImage from '@/components/shared/TokenImage';
export default function TodayTopGainers({
  subMemeData,
  onTokenClick,
  timeFrame,
  network,
  loading
}) {
  const {
    PKP
  } = useSession();
  const tokens = JSON.parse(JSON.stringify(subMemeData))?.sort((a, b) => parseFloat(b[`change${timeFrame}`]) - parseFloat(a[`change${timeFrame}`])).filter((token, idx, self) => self.findIndex(t => t.token.address === token.token.address) === idx)?.slice(0, 10).filter(token => parseFloat(token[`change${timeFrame}`]) > 0)?.map(token => {
    return {
      ...token,
      name: token.token.symbol,
      image: token.token.imageSmallUrl,
      percent: (parseFloat(token[`change${timeFrame}`]) * 100)?.toFixed(2)
    };
  });
  const router = useRouter();
  const {
    handleSaveRecent
  } = useRecentToken();
  return <div className='w-full' data-sentry-component="TodayTopGainers" data-sentry-source-file="TodayTopGainers.tsx">
      <p className='text-[16px] text-genius-gradient flex items-center px-4'>
        Gainers
        <span className='ml-1 text-xs'>
          {network?.length == 1 ? `on  ${V2Networks[network?.[0]].name}` : ''}
        </span>
      </p>
      <div className='flex items-center pt-3 space-x-4 overflow-x-scroll no-scrollbar px-4'>
        {loading ? <>
            {[...Array(3)].map((_, index) => <Skeleton key={index} className='rounded-full h-[36px] flex items-center w-[200px]' />)}
          </> : <>
            {' '}
            {tokens?.length ? <>
                {' '}
                {tokens?.map((token, index) => {
            const tokenItem = token.token;
            return <div onClick={() => {
              if (onTokenClick) {
                LogToMixpanel({
                  pkp: PKP,
                  eventName: EVENTS.search.clickTopToken,
                  category: CATEGORIES.search,
                  metaData: {
                    tokenAddress: tokenItem?.address,
                    networkId: tokenItem?.networkId
                  }
                });
                onTokenClick(tokenItem);
                handleSaveRecent({
                  tokenData: {
                    ...token,
                    ...tokenItem,
                    address: tokenItem?.address,
                    networkId: tokenItem?.networkId,
                    imageLargeUrl: tokenItem?.imageLargeUrl,
                    symbol: tokenItem?.symbol,
                    token: tokenItem,
                    timeStamp: Date.now()
                  }
                });
              } else {
                router.push(`/asset?address=${tokenItem?.address}&networkId=${tokenItem?.networkId}`);
              }
            }} key={index} className='rounded-full h-[36px] flex items-center w-fit bg-genius-blue p-[20px] pl-[10px] border-genius-blue border-[1px]'>
                      <div className='w-fit flex items-center relative'>
                        <TokenImage mainImageSrc={token?.image?.replace('large', 'small')} badgeImageSrc={getNetworkLogo(token.token.networkId)} size={28} badgeSize={14} />
                        <div className='flex items-center'>
                          <p className='text-[14px] ml-2 text-genius-cream'>{token.name}</p>
                        </div>
                        <div className='flex items-center text-green-400 ml-2'>
                          <IoTriangle className='w-[10px] h-[10px]' />
                          <p className='text-[12px]'>{token.percent}%</p>
                        </div>
                      </div>
                    </div>;
          })}
              </> : <>
                {subMemeData ? <>
                    {' '}
                    <div className='text-sm text-genius-cream/50'>No Positive Gainers</div>
                  </> : <></>}
              </>}
          </>}
      </div>
    </div>;
}